var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useState } from 'react';
import cx from 'classnames';
import { IconGroupContext, defaultConfig, useIconGroup } from './icon-group-context';
import { Group, Item } from './styles';
export const IconGroup = (_a) => {
    var { borderless } = _a, props = __rest(_a, ["borderless"]);
    const [selected, setSelected] = useState();
    const handleSelected = (value) => {
        setSelected(value);
    };
    return (React.createElement(IconGroupContext.Provider, { value: Object.assign(Object.assign({}, defaultConfig), { selected, onSelected: handleSelected }) },
        React.createElement(Group, { className: cx('icon-group', props.className), borderless: borderless, "data-role": "icon-group" }, props.children)));
};
let id = 0;
export const IconGroupItem = (props) => {
    const { selected, onSelected } = useIconGroup();
    id += 1;
    const [itemKey] = useState(id);
    const controlledItemKey = props.itemKey || itemKey;
    const isSelected = !!(selected && selected === controlledItemKey);
    const handleClick = (e) => {
        var _a;
        (_a = props.onClick) === null || _a === void 0 ? void 0 : _a.call(props, e);
        onSelected === null || onSelected === void 0 ? void 0 : onSelected(controlledItemKey);
    };
    return (React.createElement(Item, { onClick: handleClick, isSelected: isSelected, color: props.color, "data-role": "icon-group-item", className: cx('icon-group-item', props.className) }, props.children));
};
